import { createFileRoute } from '@tanstack/react-router';
import { HomeModule } from '@/mobile/modulos/home/HomeModule';

export const Route = createFileRoute('/m/')({
  component: HomeModule,
});
